import { portfolioConstants } from "../_constants";
("use strict");

import { from, of } from "rxjs";
import { ajax } from "rxjs/ajax";
import { ofType } from "redux-observable";
import { mergeMap, catchError, map, concatMap } from "rxjs/operators";

import { getRequestHeader } from "../../_helpers/request.header";
import { payloadFormatter } from "../../_helpers/encryption.helper";
import {
  accountSummaryComplete,
  accountSummaryError,
  ajaxError,
} from "../_actions";

export const accountSummaryListsEpic = (actions$) =>
  actions$.pipe(
    ofType(portfolioConstants.MY_PORTFOLIO_ACCOUNT_SUMMARY_REQUEST),
    mergeMap((action) => {
      const accountType = action.payload?.accountType;
      return ajax
        .post(
          "/api/myPortfolio/getAccountSummary",
          action.payload,
          getRequestHeader("POST"),
        )
        .pipe(
          map((ajaxResponse) =>
            accountSummaryComplete({
              ...ajaxResponse.response,
              accountType,
            }),
          ),

          catchError((error) =>
            of(accountSummaryError(error), ajaxError(error)),
          ),
        );
    }),
  );
